import { XeoAddOnPlanEnum } from './xeo-addon-plan';

export interface XeoAddonPlanContent {
  name: XeoAddOnPlanEnum;
  priceMonthly: number | null;
  priceYearly: number | null;
  features: string[];
}

export const xeoAddOnPlansContent: XeoAddonPlanContent[] = [
  {
    name: XeoAddOnPlanEnum.XEO_RVT,
    priceMonthly: null,
    priceYearly: null,
    features: [
      '30-day free trial, 60 days with xeoIntegrator',
      'Processed models include a watermark',
      'Process Revit® .rvt, .rfa files',
      'Generate optimized web-ready BIM models',
      'Use processed models in xeoVision',
      'Available for custom backend workflows',
    ],
  },
];
